const preconnectUrls = ['https://p.typekit.net', 'https://use.typekit.net'];

export default preconnectUrls;
